
<div class="status-sm-chart-01">
  @if (series) {
    <apx-chart  [chart]="chart"
      [plotOptions]="plotOptions"
      [dataLabels]="dataLabels"
      [stroke]="stroke"
      [series]="series"
      [fill]="fill"
      [colors]="colors"
      [tooltip]="toolTip">
    </apx-chart>
  }
</div>



